export { default } from './PartnersProgramsList';
